import React, { useReducer, createContext } from "react";
import bookmarkReducer from "../reducers/bookmarkReducer";

export const BookmarkContext = createContext();

const BookmarkProvider = BookmarkContext.Provider;

export function BookmarkWrapper({ children }) {
  const storedBookmark =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("bookmark"))
      : null;
  const [bookmark, dispatchBookmark] = useReducer(
    bookmarkReducer,
    storedBookmark || []
  );

  return (
    <BookmarkProvider value={{ bookmark, dispatchBookmark }}>
      {children}
    </BookmarkProvider>
  );
}
